// extracted by css-extract-rspack-plugin
export default {"Card":"DefinitionIceBreakers-module__Card__MUnrQ","CardHeading":"DefinitionIceBreakers-module__CardHeading__O16eb","Link":"DefinitionIceBreakers-module__Link__JIrMx"};